// Single source of truth for the assessment's advertised duration (KAN-210).
// Several surfaces show "~20 minutes" — the home hero meta, the welcome card, and
// the i18n `test.duration` string. Deriving them all from this constant keeps the
// number from drifting apart again. (The FAQ "15–20 minutes" range and the
// "20 questions" count are intentionally separate copy.)
export const TEST_DURATION_MINUTES = 20;
